import { render, staticRenderFns } from "./VDateMonth.vue?vue&type=template&id=60018de9&scoped=true"
import script from "./VDateMonth.vue?vue&type=script&lang=js"
export * from "./VDateMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60018de9",
  null
  
)

export default component.exports